var _rect, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceCenterProductLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 36,
    viewBox: "0 0 220 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10.2858,
    width: 20.5448,
    height: 20.5714,
    rx: 2,
    fill: "url(#paint0_linear_2012_214)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.4086,
    width: 30.8171,
    height: 30.8571,
    rx: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4086,
    width: 30.8171,
    height: 30.8571,
    rx: 2,
    fill: "url(#paint1_linear_2012_214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4086,
    width: 30.8171,
    height: 30.8571,
    rx: 2,
    fill: "url(#paint2_linear_2012_214)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2012_214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0896 9.42852L35.9534 17.9999H30.8172L25.681 23.1428L20.5449 25.7142H15.4087H12.8406V33.4285H49.6499V8.57138L46.2258 7.71423L41.0896 9.42852Z",
    fill: "url(#paint3_linear_2012_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1739 22.4384L20.3427 24.8571H11.9845V26.5714H20.7469L26.1881 23.8472L31.1718 18.8571H36.438L41.6607 10.1414L46.26 8.60632L46.1915 6.82214L40.5184 8.71563L35.4687 17.1428H30.4626L25.1739 22.4384Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2012_214)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2012_214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8017 8.57141L37.6655 13.7143L28.2491 17.1428L27.3931 20.5714L21.4009 25.7143H15.4087H12.8406V33.4285H49.6499V8.57141H46.2258H42.8017Z",
    fill: "url(#paint4_linear_2012_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8017 8.57141L37.6655 13.7143L28.2491 17.1428L27.3931 20.5714L21.4009 25.7143H15.4087H12.8406V33.4285H49.6499V8.57141H46.2258H42.8017Z",
    stroke: "white",
    strokeWidth: 2
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5496 30.8572H17.4086C16.304 30.8572 15.4086 29.9618 15.4086 28.8572V10.2858H18.5448C19.6493 10.2858 20.5448 11.1812 20.5448 12.2858V28.8572C20.5448 29.9602 19.6519 30.8546 18.5496 30.8572Z",
    fill: "url(#paint5_linear_2012_214)",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.094 17.1543V4.33472H215.852C218.343 4.33472 219.968 5.82765 219.968 8.36654C219.968 10.9054 218.343 12.4162 215.852 12.4162H212.558V17.1543H210.094ZM212.558 10.2171H215.576C216.826 10.2171 217.495 9.50188 217.495 8.36654C217.495 7.23119 216.826 6.53389 215.576 6.53389H212.558V10.2171Z",
    fill: "#18191B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.344 17.1543V6.53389H196.925V4.33472H208.264V6.53389H203.817V17.1543H201.344Z",
    fill: "#18191B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.577 17.1543V4.33473H187.041V9.64493H192.621V4.33473H195.094V17.1543H192.621V11.8441H187.041V17.1543H184.577Z",
    fill: "#18191B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.488 17.1543V4.33472H182.175V6.53389H174.952V9.484H181.077V11.6832H174.952V14.9551H182.362V17.1543H172.488Z",
    fill: "#18191B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.578 19.8094H168.185V17.1543H158.239V4.33473H160.703V14.9551H166.176V4.33473H168.64V14.9551H170.56L170.578 19.8094Z",
    fill: "#18191B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.909 4.33473H150.945V17.1543H148.472V7.69607L143.026 17.1543H140.008V4.33473H142.472V13.784L147.909 4.33473ZM142.07 0.857178H144.061C144.133 1.50978 144.642 1.86737 145.401 1.86737C146.159 1.86737 146.695 1.50978 146.767 0.857178H148.758C148.722 2.52891 147.543 3.42288 145.401 3.42288C143.249 3.42288 142.106 2.53785 142.07 0.857178Z",
    fill: "#18191B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.276 10.7445C125.24 6.70376 127.847 4.11124 131.49 4.15594C135.133 4.11124 137.758 6.70376 137.713 10.7445C137.758 14.7853 135.133 17.3778 131.49 17.3331C127.847 17.3778 125.24 14.7853 125.276 10.7445ZM131.401 15.1429H131.588C133.865 15.1429 135.24 13.4801 135.24 10.7445C135.24 8.00002 133.865 6.35511 131.588 6.35511H131.401C129.124 6.35511 127.749 8.00002 127.749 10.7445C127.749 13.4801 129.124 15.1429 131.401 15.1429Z",
    fill: "#18191B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.795 17.1543V4.33473H119.464C121.857 4.30791 123.419 5.82767 123.392 7.65137C123.392 8.41125 123.196 9.05491 122.794 9.58236C122.401 10.1098 121.884 10.4674 121.232 10.6551C122.607 10.9412 123.669 12.0587 123.669 13.7483C123.696 15.6524 121.973 17.1901 119.643 17.1543H113.795ZM116.259 9.5913H119.098C120.285 9.5913 120.928 9.05491 120.928 8.05366C120.928 7.05241 120.285 6.53391 119.098 6.53391H116.259V9.5913ZM116.259 14.9551H119.276C120.491 14.9551 121.196 14.4009 121.196 13.3281C121.196 12.2553 120.491 11.719 119.276 11.719H116.259V14.9551Z",
    fill: "#18191B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0634 10.7445C99.0277 6.70377 101.635 4.11125 105.277 4.15595C108.92 4.11125 111.545 6.70377 111.5 10.7445C111.545 14.7853 108.92 17.3778 105.277 17.3331C101.635 17.3778 99.0277 14.7853 99.0634 10.7445ZM105.188 15.1429H105.376C107.652 15.1429 109.027 13.4801 109.027 10.7445C109.027 8.00003 107.652 6.35512 105.376 6.35512H105.188C102.911 6.35512 101.537 8.00003 101.537 10.7445C101.537 13.4801 102.911 15.1429 105.188 15.1429Z",
    fill: "#18191B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2602 17.1543V4.33473H88.7244V9.64493H94.3045V4.33473H96.7776V17.1543H94.3045V11.8441H88.7244V17.1543H86.2602Z",
    fill: "#18191B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1713 17.1543V4.33472H83.8583V6.53389H76.6355V9.484H82.7602V11.6832H76.6355V14.9551H84.0458V17.1543H74.1713Z",
    fill: "#18191B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2609 19.8094H69.8682V17.1543H59.9222V4.33473H62.3864V14.9551H67.8594V4.33473H70.3235V14.9551H72.2431L72.2609 19.8094Z",
    fill: "#18191B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M159.739 24.8555H161.528V30.8589H160.395V26.1365L158.906 30.8589H157.64L156.105 26.1198V30.8589H154.976V24.8555H156.774L158.279 29.5653L159.739 24.8555Z",
    fill: "#88919A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.649 27.8572C147.633 25.9649 148.854 24.7508 150.559 24.7718C152.265 24.7508 153.494 25.9649 153.474 27.8572C153.494 29.7495 152.265 30.9636 150.559 30.9426C148.854 30.9636 147.633 29.7495 147.649 27.8572ZM150.518 29.917H150.605C151.672 29.917 152.315 29.1383 152.315 27.8572C152.315 26.5719 151.672 25.8016 150.605 25.8016H150.518C149.451 25.8016 148.808 26.5719 148.808 27.8572C148.808 29.1383 149.451 29.917 150.518 29.917Z",
    fill: "#88919A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M141.142 27.8572C141.129 26.0151 142.204 24.755 144.01 24.7718C145.545 24.755 146.456 25.6844 146.527 26.8273H145.373C145.244 26.1742 144.775 25.8016 144.052 25.8016H143.968C142.986 25.7891 142.288 26.5929 142.3 27.8572C142.3 29.1257 142.977 29.917 143.968 29.917H144.052C144.784 29.917 145.244 29.5569 145.373 28.8871H146.527C146.452 30.076 145.553 30.9552 144.01 30.9426C142.204 30.9594 141.129 29.6993 141.142 27.8572Z",
    fill: "#88919A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.745 30.8589V29.6155H139.986V30.8589H138.745Z",
    fill: "#88919A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.773 30.8589H136.41L135.013 28.7531L133.592 30.8589H132.291L134.365 27.7818L132.421 24.8555H133.78L135.051 26.7687L136.343 24.8555H137.643L135.699 27.74L137.773 30.8589Z",
    fill: "#88919A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M126.896 30.8589V24.8555H131.433V25.8854H128.05V27.2669H130.918V28.2968H128.05V29.829H131.52V30.8589H126.896Z",
    fill: "#88919A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.569 27.8572C119.553 25.9649 120.773 24.7508 122.479 24.7718C124.185 24.7508 125.414 25.9649 125.394 27.8572C125.414 29.7495 124.185 30.9636 122.479 30.9426C120.773 30.9636 119.553 29.7495 119.569 27.8572ZM122.438 29.917H122.525C123.592 29.917 124.235 29.1383 124.235 27.8572C124.235 26.5719 123.592 25.8016 122.525 25.8016H122.438C121.371 25.8016 120.727 26.5719 120.727 27.8572C120.727 29.1383 121.371 29.917 122.438 29.917Z",
    fill: "#88919A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.277 24.8555H118.067V30.8589H116.934V26.1365L115.445 30.8589H114.178L112.644 26.1198V30.8589H111.515V24.8555H113.313L114.818 29.5653L116.277 24.8555Z",
    fill: "#88919A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M108.607 30.8589V29.6155H109.849V30.8589H108.607Z",
    fill: "#88919A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M103.542 30.8589V24.8555H106.239C107.406 24.8555 108.167 25.5546 108.167 26.7436C108.167 27.9326 107.406 28.6401 106.239 28.6401H104.696V30.8589H103.542ZM104.696 27.6102H106.11C106.695 27.6102 107.009 27.2753 107.009 26.7436C107.009 26.2119 106.695 25.8854 106.11 25.8854H104.696V27.6102Z",
    fill: "#88919A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2156 27.8572C96.1988 25.9649 97.4197 24.7508 99.1256 24.7718C100.831 24.7508 102.061 25.9649 102.04 27.8572C102.061 29.7495 100.831 30.9636 99.1256 30.9426C97.4197 30.9636 96.1988 29.7495 96.2156 27.8572ZM99.0838 29.917H99.1716C100.238 29.917 100.882 29.1383 100.882 27.8572C100.882 26.5719 100.238 25.8016 99.1716 25.8016H99.0838C98.0176 25.8016 97.3737 26.5719 97.3737 27.8572C97.3737 29.1383 98.0176 29.917 99.0838 29.917Z",
    fill: "#88919A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7918 30.8589V24.8555H90.9458V27.3423H93.5589V24.8555H94.7171V30.8589H93.5589V28.3721H90.9458V30.8589H89.7918Z",
    fill: "#88919A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4809 28.8452H84.639C84.6808 29.4606 85.1324 29.917 86.0104 29.917H86.094C86.7212 29.917 87.0724 29.5862 87.0724 29.1885C87.0724 28.8243 86.9094 28.6317 86.3951 28.527L85.3247 28.3052C84.2753 28.0833 83.7819 27.4888 83.7819 26.5719C83.7652 25.6593 84.6349 24.755 86.0522 24.7718C87.4738 24.7592 88.3351 25.6049 88.3226 26.7436H87.1644C87.1268 26.1365 86.6878 25.8016 86.0522 25.8016H85.9644C85.3415 25.8016 84.9401 26.1407 84.9401 26.5301C84.9401 26.9194 85.1491 27.1036 85.6676 27.2083L86.5665 27.3883C87.6327 27.6018 88.2264 28.1586 88.2264 29.1006C88.2389 30.1305 87.3609 30.9552 85.9226 30.9426C84.3087 30.9426 83.531 30.1137 83.4809 28.8452Z",
    fill: "#88919A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6312 30.8589L81.0918 29.4439H78.5748L78.0355 30.8589H76.8188L79.1894 24.8555H80.5441L82.8562 30.8589H81.6312ZM78.9637 28.414H80.6988L79.8291 26.1365L78.9637 28.414Z",
    fill: "#88919A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6897 30.8589V25.8854H71.62V24.8555H76.93V25.8854H74.8478V30.8589H73.6897Z",
    fill: "#88919A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4727 30.8589L69.9334 29.4439H67.4164L66.877 30.8589H65.6603L68.031 24.8555H69.3857L71.6978 30.8589H70.4727ZM67.8052 28.414H69.5404L68.6707 26.1365L67.8052 28.414Z",
    fill: "#88919A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9222 30.8589V24.8555H61.9751C63.7855 24.8471 65.0273 25.923 65.0148 27.8572C65.0273 29.7955 63.8232 30.8715 62.0211 30.8589H59.9222ZM61.0762 29.829H61.8915C62.5145 29.829 62.9995 29.6783 63.3424 29.3769C63.6894 29.0755 63.8608 28.5689 63.8608 27.8572C63.8608 27.1497 63.6894 26.6431 63.3424 26.3417C62.9995 26.0361 62.5145 25.8854 61.8915 25.8854H61.0762V29.829Z",
    fill: "#88919A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2012_214",
    x: 9.84058,
    y: 5.57141,
    width: 42.8093,
    height: 30.8572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2012_214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2012_214",
    x1: 10.2724,
    y1: 10.2858,
    x2: 10.2724,
    y2: 30.8572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2012_214",
    x1: 30.8171,
    y1: 0,
    x2: 30.8171,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2012_214",
    x1: 30.8171,
    y1: 0,
    x2: 30.8171,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2012_214",
    x1: 31.2452,
    y1: 8.57138,
    x2: 31.2452,
    y2: 33.4285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2012_214",
    x1: 31.2453,
    y1: 8.57141,
    x2: 31.2453,
    y2: 33.4285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2012_214",
    x1: 30.8171,
    y1: 10.2858,
    x2: 30.8171,
    y2: 30.8572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFD1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2012_214"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5448,
    width: 25.6809,
    height: 30.8571,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2012_214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.13619,
    height: 30.8571,
    rx: 2,
    transform: "matrix(-1 0 0 1 20.5448 0)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceCenterProductLogo);
export default __webpack_public_path__ + "static/media/PriceCenterProductLogo.c74947a41b989204e4d92a56a0f11d40.svg";
export { ForwardRef as ReactComponent };